import React, { Component } from "react";
import actions from '../actions';
import { connect } from 'react-redux';
import EntitiesPage from '../components/EntitiesPage';
import ObjectUtils from '../../shared/utils/ObjectUtils';
import { I18n } from 'react-redux-i18n';

class EntitiesPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            universalSearchField: "",
            searchFieldsValues: {
                name: {
                    value: ""
                },
                parentId: {
                    value: ""
                },
                type: {
                    value: "",
                    data: [{ value: 'basic', label: I18n.t("entities.types.basic")},
                        { value: 'company', label: I18n.t("entities.types.company")},
                        { value: 'region', label: I18n.t("entities.types.region")},
                        { value: 'building', label: I18n.t("entities.types.building")},
                        { value: 'floor', label: I18n.t("entities.types.floor")},
                        { value: 'meetingRoom', label: I18n.t("entities.types.meetingRoom")},
                    ]
                }
            }
        }
    }

    componentDidMount() {
        const { getEntityList } = this.props;

        getEntityList();
        this.fetchData()
    }

    fetchData = (currentPage, itemsPerPage, sortProperty, sortDirection) => {
        let { 
            searchFieldsValues, 
            universalSearchField 
        } = this.state;

        if(currentPage === undefined){
            if(this.props.location.state?.searchFieldsData !== undefined){
                searchFieldsValues =  this.props.location.state.searchFieldsData;
                this.handleSearchFieldValuesChange(searchFieldsValues);
            }
            if(this.props.location.state?.universalSearchField !== undefined ){
                universalSearchField = this.props.location.state.universalSearchField;
                this.handleUniversalSearchFieldChange(universalSearchField);
            }
        }

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                { ...acc } : { ...acc, [keyValuePair[0]]: keyValuePair[1].value }
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchEntities({
            ...filter,
            currentPage: currentPage,
            itemsPerPage: itemsPerPage,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    }

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    }

    handleSearchFieldValuesChange = (value) => {
        this.setState({
            searchFieldsValues: value
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    }

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    }

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    }

    handleSortChanged = newSort => {
        const { 
            table:  { 
                pageNumber, 
                pageSize 
            } 
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    }

    handleAddButtonClicked = () => {
        this.props.history.push('/entities/create');
    }

    handleRowClicked = entity => {
        this.props.history.push({
            pathname: '/entities/' + entity.id,
            state: { searchFieldsData : this.state.searchFieldsValues, universalSearchField: this.state.universalSearchField }
        });
    }

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            entityList
        } = this.props;

        return (
            <EntitiesPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}
                handleAddButtonClicked={this.handleAddButtonClicked}

                data={data}
                sort={sort}
                totalElements={totalElements}
                entityList={entityList}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
            />
        );
    }
}

const mapStateToProps = ({ entitiesReducer }) => {
    return {
        searchFieldsData: entitiesReducer.searchFieldsData,
        entityList: entitiesReducer.entityList,
        table: entitiesReducer.table
    };
};

const mapDispatchToProps = {
    searchEntities: actions.searchEntities,
    getEntityList: actions.getEntityList,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EntitiesPageContainer);